export const FooterData = [
      
    {
        Link: "/Aboutsus",
        Components: "About Us",
    },
    {
        Link: "/Blogs",
        Components: "Blog",
    },
    {
        Link: "/Contact",
        Components: "Contact Us",
    },
    {
        Link: "/TermsAndConditions",
        Components: "Terms And Conditions",
    },
    {
        Link: "/PrivacyPolicy",
        Components: "Privacy Policy",
    },
    // {
    //     Link: "/Review",
    //     Components: "Review",
    // },
    
  
];
export const FooterData2 = [
    {
        Link: "/Contact",
        Components: "Contact Us",
    },
    {
        Link: "/Portfolio",
        Components: "Portfolio",
    },
    {
        Link: "/Blog",
        Components: "Blog",
    },
    {
        Link: "/OurTeam",
        Components: "Our Team",
    },
  
];
export const FooterData3 = [
   
    // {
    //     Link: "/Portfolio",
    //     Components: "Portfolio",
    // },
    // {
    //     Link: "/Blog",
    //     Components: "Blog",
    // },
    // {
    //     Link: "/OurTeam",
    //     Components: "Our Team",
    // },
    {
        Link: "/SSF",
        Components: "SSF",
    },
    {
        Link: "/Insurance",
        Components: "Insurance",
    },
];
 